import { Reveal, RevealStagger, revealItem } from "@/components/Reveal";
import { motion } from "framer-motion";
import { UNIT_SIZES } from "@/constants/content";
import { LeadCTAs } from "@/components/LeadCTAs";
import { openLeadForm } from "@/utils/openLeadForm";

export const UnitSizes = () => (
  <section id="unit-sizes" className="cp-section cp-section--white" data-testid="unit-sizes-section">
    <div className="cp-container">
      <Reveal className="cp-section-head">
        <span className="cp-eyebrow">Available SCO Sizes</span>
        <h2 className="cp-h2">Sixteen Units. Six Configurations. One Address.</h2>
      </Reveal>

      <RevealStagger className="cp-units-grid" stagger={0.07}>
        {UNIT_SIZES.map((u) => (
          <motion.div key={u.unitNos} variants={revealItem} className="cp-unit-card" data-testid={`unit-card-${u.unitNos.split(",")[0].trim().replace(/\s/g, "")}`}>
            <div className="cp-unit-card-top">
              {/* <span className="cp-unit-size">{u.size} <small>SQ. YRDS</small></span> */}
              <span className="cp-unit-size cp-unit-size--config">Configuration</span>
              <span className="cp-unit-badge">Available</span>
            </div>
            <div className="cp-unit-nos">SCO {u.unitNos}</div>
            <div className="cp-unit-units">{u.units} {u.units > 1 ? "Units" : "Unit"} in this configuration</div>
            <button
              type="button"
              className="btn btn-gold btn-sm cp-card-check-prices"
              onClick={() =>
                openLeadForm({
                  message: `Interested in Central Plaza SCO ${u.unitNos} — please share pricing.`,
                })
              }
              data-testid={`unit-check-prices-${u.unitNos.split(",")[0].trim().replace(/\s/g, "")}`}
            >
              Check Prices
            </button>
          </motion.div>
        ))}
      </RevealStagger>
      <Reveal delay={0.15} className="cp-units-note">
        Exclusive pre-launch offer — contact sales for configuration, size, and pricing details.
      </Reveal>
      <Reveal delay={0.2}>
        <LeadCTAs className="cp-units-ctas" enquireTestId="unit-sizes-enquire-btn" waTestId="unit-sizes-whatsapp-btn" />
      </Reveal>
    </div>
  </section>
);
